import Voice from './Voice.vue';

export default Voice;
